import { toast } from "react-toastify";
import { SessionTimeout } from "../../../Utils/ErrorMessages";
import { executePost } from "../../../Utils/ServiceMethods";
import { removeUserCredentials } from "../../../Utils/LocalStorage";

export const DisableVoucherCouponApi = async (data, cb) => {
  try {
    const DisableVoucherCoupon = await executePost(
      "/in_active_couponvouhcer",
      data
    );
    const DisableVoucherCouponData = DisableVoucherCoupon.data
      ? DisableVoucherCoupon.data
      : {};
    return DisableVoucherCouponData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};